import React from "react";
import { Table, List, Space, Row, Col, Typography } from "antd";
import { ListRecordAttributeItem } from 'components';
import moment from 'moment';

const { Column } = Table;
const { Title, Text, Link } = Typography;

const displayLabels = {
    "email": "Email",
    "firstName": "First name",
    "lastName": "Last name",
    "actions": "Used for Tagging",
    "canAdd": "Add",
    "canView": "View",
    "canEdit": "Edit",
    "canDelete": "Delete",
    "active": "Active",
    "updatedByEmail": "Updated by",
    "updatedDate": "Updated at",
    "deleted": "Deleted"
}

function parseAction(user) {
    if (user && user.actions) {
        user.canAdd = false;
        user.canView = false;
        user.canEdit = false;
        user.canDelete = false;
        if (user.actions.includes("add")) {
            user.canAdd = true;
        }
        if (user.actions.includes("view")) {
            user.canView = true;
        }
        if (user.actions.includes("edit")) {
            user.canEdit = true;
        }
        if (user.actions.includes("delete")) {
            user.canDelete = true;
        }
        delete user.actions;
    }
}

export default function ({ record }) {
    let currentData = { ...record.data };
    let previousData = { ...(record.previousData || {}) };
    if (currentData && currentData.user) {
        parseAction(currentData.user);
    }
    if (previousData && previousData.user) {
        parseAction(previousData.user);
    }
    return <>
        <Row className="middle-row">
            <Col span={24}>
                <Title level={5}><Text>{record.name}</Text></Title>
            </Col>
        </Row>
        <Row>
            <Col span={24}>
                <List
                    size="small"
                    bordered
                    dataSource={Object.keys(currentData)}
                    renderItem={item => {
                        if (item === "user") {
                            let currentUserItem = currentData["user"];
                            let previousUserItem = previousData && previousData["user"];
                            return Object.keys(currentUserItem).map(userKey => {
                                if (displayLabels[userKey]) {
                                    return <ListRecordAttributeItem name={displayLabels[userKey]} value={currentUserItem[userKey]} previousValue={previousUserItem && previousUserItem[userKey]}></ListRecordAttributeItem>
                                }
                                return <></>
                            });
                        }
                        if (displayLabels[item]) {
                            if (item === "updatedDate") {
                                return <ListRecordAttributeItem name={displayLabels[item]} value={moment.utc(currentData[item]).toDate().toLocaleString()} previousValue={previousData[item] && moment.utc(previousData[item]).toDate().toLocaleString()}></ListRecordAttributeItem>
                            }
                            return <ListRecordAttributeItem name={displayLabels[item]} value={currentData[item]} previousValue={previousData && previousData[item]}></ListRecordAttributeItem>
                        }
                        return <></>
                    }}
                />
            </Col>
        </Row>
    </>
}